import { render } from "./block.vue?vue&type=template&id=2e585c78&scoped=true"
import script from "./block.vue?vue&type=script&lang=js"
export * from "./block.vue?vue&type=script&lang=js"

import "./block.vue?vue&type=style&index=0&id=2e585c78&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e585c78"]])

export default __exports__